import React from "react";
import { getStatusCfg } from "./statusHelpers";

/**
 * DateBox
 * The colored square on the left of each attendance row.
 * Props:
 *   dayNum     — "09"
 *   monthShort — "JUN"
 *   dayName    — "Tue"
 *   status     — attendance status string
 */
export default function DateBox({ dayNum, monthShort, dayName, status }) {
  const cfg = getStatusCfg(status);
  const isPresent = status === "Present";

  return (
    <div
      className="w-14 h-14 rounded-xl flex flex-col items-center justify-center flex-shrink-0 mr-3"
      style={{
        backgroundColor: isPresent ? "rgba(253,199,0,0.10)" : cfg.text + "14",
        border: `1px solid ${isPresent ? "rgba(253,199,0,0.30)" : cfg.text + "35"}`,
      }}
    >
      <span
        className="text-lg font-black leading-tight"
        style={{ color: isPresent ? "#FDC700" : cfg.text }}
      >
        {dayNum}
      </span>
      <span className="text-[8px] font-semibold text-gray-400 uppercase tracking-wide">
        {monthShort}
      </span>
      <span className="text-[7px] text-gray-400 mt-px">{dayName}</span>
    </div>
  );
}